var render, staticRenderFns;
import script from "./overflow-tooltip-text.vue?vue&type=script&lang=js";
export * from "./overflow-tooltip-text.vue?vue&type=script&lang=js";
import style0 from "./overflow-tooltip-text.vue?vue&type=style&index=0&id=611eb908&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;